import './App.css';
import Navbar from './components/Navbar/Navbar';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import Home from './pages/Home/Home';
import Footer from './components/Footer/Footer';
import AboutPage from './pages/About/About';
import ContactPage from './pages/Contact/Contact';
import WorksPage from './pages/Works/Works';
import ServicesPage from './pages/Services/Services';
import HirePage from './pages/Hire/Hire';
import PricingPage from './pages/Pricing/Pricing';
import SalesPage from './pages/SalesPage/Sales';

function App() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return (
    <div className="App">
      <div className="App-overlay"></div>
      <Navbar />

        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/home" element={<Home />} />
          <Route exact path="/about" element={<AboutPage />} />
          <Route exact path="/services" element={<ServicesPage />} />
          <Route exact path="/works" element={<WorksPage />} />
          {/* <Route exact path="/hire" element={<HirePage />} /> */}
          <Route exact path="/contact" element={<ContactPage />} />
          <Route exact path="/pricing" element={<PricingPage />} />
          <Route exact path="/sales" element={<SalesPage />} />
        </Routes>

      <Footer />
    </div>
  );
}

export default App;